"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.systemRowId = void 0;
exports.surfaceRows = surfaceRows;
exports.rowsBeforeOption = rowsBeforeOption;
// A measured surface as the Take Off's rows for one option: the surface
// itself (its first paint system), then each extra paint system on the same
// measurement (#412, docs/SURFACE-NAMES.md). Which value wins (SCHEMA.md):
// the option's, else the area's own override, else (spread) the paint's
// coverage, else the surface type's default. An extra system's prep starts at
// none (MJ, 2026-10-20). Pure.
const measure_ts_1 = require("./measure.js");
const surfaces_ts_1 = require("./surfaces.js");
const given = (value, fallback) => (typeof value === 'number' ? value : fallback);
/** A paint's coverage: the chosen paint, else the option's first (as pricing.ts picks it); undefined when it has none. */
function paintSpread(paintKey, paints) {
    return (paints.find((p) => p.id === paintKey) ?? paints[0])?.spreadRate;
}
/** A surface's settings before this option's own values, painted with `paintKey`. */
function settingsBeforeOption(surface, type, paintKey, paints) {
    const measured = (0, measure_ts_1.effectiveSettings)(surface, type);
    return { ...measured, spread: surface.spread ?? paintSpread(paintKey, paints) ?? measured.spread };
}
const pick = ({ coats, rate, spread }) => ({ coats, rate, spread });
/** A row's id: the surface's own, or `<surface>:<system>` for an extra paint system. */
const systemRowId = (surfaceId, systemId) => `${surfaceId}:${systemId}`;
exports.systemRowId = systemRowId;
/** "Paint system 2" for the first extra system without a name (the surface's own is system 1). */
const systemName = (system, index) => system.name ?? `Paint system ${index + 2}`;
function systemRow(first, system, index, before) {
    return {
        ...first,
        id: (0, exports.systemRowId)(first.id, system.id),
        name: systemName(system, index),
        systemOf: first.id,
        coats: given(system.coats, before.coats),
        rate: given(system.rate, before.rate),
        prep: given(system.prep, 0),
        spread: given(system.spread, before.spread),
        paintId: system.paint,
    };
}
/** The surface's priced rows for this option. `count` is its repeat group's; `paints` the option's priced paints. */
function surfaceRows(surface, type, choice, count, paints) {
    const measured = settingsBeforeOption(surface, type, choice?.paint, paints);
    const first = {
        id: surface.id,
        name: (0, surfaces_ts_1.surfaceLabel)(surface),
        unit: surface.unit,
        quantity: (0, measure_ts_1.surfaceTotals)(surface, type, count).quantity,
        uplift: measured.uplift,
        girth: measured.girth,
        coats: given(choice?.coats, measured.coats),
        rate: given(choice?.rate, measured.rate),
        prep: given(choice?.prep, measured.prep),
        spread: given(choice?.spread, measured.spread),
        pitchInQuantity: surface.method === measure_ts_1.METHOD.roof,
        paintId: choice?.paint,
    };
    const systems = (choice?.systems ?? []).map((system, i) => systemRow(first, system, i, settingsBeforeOption(surface, type, system.paint, paints)));
    return [first, ...systems];
}
/** Each of the surface's rows (by row id) as it is before this option's values: what clearing a typed value goes back to. */
function rowsBeforeOption(surface, type, choice, paints) {
    const own = [surface.id, pick(settingsBeforeOption(surface, type, choice?.paint, paints))];
    const systems = (choice?.systems ?? []).map((system) => [(0, exports.systemRowId)(surface.id, system.id), pick(settingsBeforeOption(surface, type, system.paint, paints))]);
    return [own, ...systems];
}
